import React from 'react'
import LinePlaneDepartureIcon from 'components/Luxkit/Icons/line/LinePlaneDepartureIcon'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { pluralizeToString } from 'lib/string/pluralize'

interface Props {
  rooms?: Array<App.RoomOccupants>,
  isFlightEnabled: boolean,
  duration: number,
  shouldDisplayRoom: boolean,
  shouldDisplayFlight?: boolean,
  saleUnit: string,
}

function MobileMultipleRoomsDurationLabel(props: Props) {
  const {
    rooms,
    isFlightEnabled,
    duration,
    shouldDisplayRoom = false,
    shouldDisplayFlight = true,
    saleUnit,
  } = props
  const roomCount = rooms?.length || 0
  const roomText = shouldDisplayRoom ? `, ${pluralizeToString(saleUnit, roomCount)}` : ''
  const flightText = isFlightEnabled ? ' + flights' : ''
  const durationText = `${pluralizeToString('night', duration)}`
  const resultText = durationText + roomText + flightText + ' from'

  return <>
    {isFlightEnabled && shouldDisplayFlight && <>
      <LinePlaneDepartureIcon/>
      {' '}
      {resultText}
    </>}
    {!isFlightEnabled && <>
      {resultText}
    </>}
  </>
}

export default withOfferPageAndReduxState((state, _) => ({
  duration: state.duration,
  rooms: state.rooms,
  isFlightEnabled: state.flights,
  saleUnit: state.offer?.saleUnit || 'room',
}), MobileMultipleRoomsDurationLabel)
